/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import EmbedIframe from 'material/embeds/embediframe/embediframe';



/* ========== ~~~~~~~~~~ EMBED IFRAME : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    selectedEmbedStatus: embedsState.embedManagementState.selectedEmbedStatus,
    contentStatus: embedsState.embedManagementState.contentStatus
});

// map actions
// const mapDispatchToProps = dispatch => ({
//
// });



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    // mapDispatchToProps
)(EmbedIframe);
